import {Component, Input} from '@angular/core';
import {Compbaser} from '../../../components/compbaser';
import {TranslocoService} from '@ngneat/transloco';
import {actionAccountCommandsRequest, actionLoginViewMode, actionUpdateBusinessName} from "../../../store/actions/user.actions";
import {ToastrService} from "ngx-toastr";
import {AppService, StoreSelectorsService} from "../../../services";
import {EnumLoginViewMode, IUser} from "../../../interfaces";
import {debounce} from "utils-decorators";

@Component({
    selector: 'app-business-rename',
    templateUrl: './business-rename.component.html',
    styleUrls: ['./business-rename.component.scss'],

})
export class BusinessRenameComponent extends Compbaser {
    m_user = '';
    m_pass = '';
    user: IUser;
    m_businessName = '';
    m_viewMod = EnumLoginViewMode;

    @Input() loginMode: boolean;

    constructor(private translocoService: TranslocoService,
                private appService: AppService,
                private toastr: ToastrService,
                private storeSelector: StoreSelectorsService) {
        super();
        this.cod(
            this.storeSelector.getUser().subscribe((u) => {
                this.user = u;
                this.m_businessName = this.user.businessName;
            })
        );
    }

    updateName() {
        this.storeSelector.appStore.dispatch(actionUpdateBusinessName({businessName: this.m_businessName}));
    }

    @debounce(3000)
    syncUser() {
        this.appService.syncUser();
    }

    onChangeBusinessName() {
        this.storeSelector.appStore.dispatch(actionAccountCommandsRequest({
                accountRequest: {
                    createCustomerAccount: {
                        userName: this.user.username,
                        password: this.user.passwordNew,
                        businessName: this.m_businessName
                    },
                    serverCall: 'BUSINESS_RENAME'
                }
            })
        );
        if (this.user?.dashboard) {
            this.syncUser();
        }
    }

    setViewMode(v: EnumLoginViewMode) {
        this.storeSelector.dispatch(actionLoginViewMode({loginViewMode: v}));
        // this.m_currentViewMode = v;
    }

}

